import { USER_COMPLETED_DIALOG_REGISTRATION } from './types'

const userCompletedDialogRegistration = () => ({
  type: USER_COMPLETED_DIALOG_REGISTRATION
})

export { userCompletedDialogRegistration }
